import LinkSizable from '../link-sizable/LinkSizable';
import styles from './rounded-button-link-action.module.less';

const RoundedButtonLinkAction = ({ className = '', children, buttonRef, ...restProps }) => (
    <LinkSizable className={[styles.buttonLink, className].join(' ')} {...restProps} ref={buttonRef}>
        {children}
    </LinkSizable>
);

export default RoundedButtonLinkAction;
